import React from 'react';
import { Box, Typography } from '@mui/material';

const TeamCardHeader = ({ teamName, teamRank, logoUrl }) => {
  return (
    <Box className="golf-league-team-header">
      <Box className="golf-league-team-info">
        <Typography variant="h6" className="golf-league-team-name">
          {teamName}
        </Typography>
        <Typography variant="body1" className="golf-league-team-rank">
          {teamRank}
        </Typography>
      </Box>

      {/* Logo */}
      <Box className="golf-league-team-logo">
        <img
          src={logoUrl}
          alt="Team Logo"
          width={70}
          height={70}
        />
      </Box>
    </Box>
  );
};

export default TeamCardHeader;